import React, {useEffect, useState} from 'react';
import Moment from 'moment';
import Select from 'react-select'
import { useForm } from "react-hook-form";
import { Button, CardBody, Col, Form, Input, Label, Row } from 'reactstrap';

import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import { getFirstDayOfMonth, getLastDayOfMonth, monthSelectOptions } from "../../../util/DateTools";

export default function PhotoDashboardFilters(props) {
    const date = new Date()
    const [searchByMonth, setSearchByMonth] = useState(true);
    const [monthOption, setMonthOption] = useState(null)
    const [to, setTo] = useState( getLastDayOfMonth(date.getFullYear(), date.getMonth()) );
    const [from, setFrom] = useState( getFirstDayOfMonth(date.getFullYear(), date.getMonth()) );
    const [resetValues, setResetValues] = useState(false);

    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            to : Moment(to).format('YYYY-MM-DD'),
            from : Moment(from).format('YYYY-MM-DD')
        }
    });

    useEffect(() => {
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const itemOption = monthSelectOptions.find( it => it.value === month );

        const firstDate = getFirstDayOfMonth( date.getFullYear(), date.getMonth() );
        const lastDay = getLastDayOfMonth( date.getFullYear(), date.getMonth() );

        setMonthOption(itemOption);
        setTo( firstDate );
        setFrom( lastDay );
    },[])

    const onMonthChange = month => {
        const itemOption = monthSelectOptions.find( it => it.value === month );
        const selectedMonth = parseInt( month ) - 1;
        const nextMonth = selectedMonth === 11 ? 0 : selectedMonth + 1;
        const firstDate = getFirstDayOfMonth( date.getFullYear(), selectedMonth );
        const lastDay = getFirstDayOfMonth( date.getFullYear(), nextMonth );

        setMonthOption( itemOption );
        setTo( lastDay );
        setFrom( firstDate );
    }

    const onSubmit = (data, _) => {
        const _dataFilter = {
            to : Moment(to).format('YYYY-MM-DD'),
            from : Moment(from).format('YYYY-MM-DD')
        };

        props.refreshFiltered(_dataFilter);
    };

    const cleanFields = () => {
        setSearchByMonth( true );
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        onMonthChange(month);
        setResetValues(!resetValues);
        reset();
    }

    const changeSearch = (_searchByMonth) => {
        setSearchByMonth( _searchByMonth );

        onMonthChange(monthOption.value);
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="4">
                    <Row>
                        <Col md="4">
                            <Button onClick={_ => changeSearch(true)} >Por mes:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="12">
                            <Label>Mes</Label>
                            <Select
                                value = { monthOption }
                                options = {monthSelectOptions}
                                isClearable = { false }
                                isDisabled = { !searchByMonth }
                                onChange = { val => onMonthChange(val?.value) }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md="4">
                    <Row>
                        <Col md="4">
                            <Button onClick={_ => changeSearch(false)} >Por fecha:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="6" >
                            <Label>Desde</Label>
                            <Input type="date"
                                   name="from"
                                   value={from}
                                   disabled={ searchByMonth }
                                   onChange={e => setFrom(e.target.value)}
                                   innerRef={register}
                            />
                        </Col>
                        <Col md="6">
                            <Label>Hasta</Label>
                            <Input type="date"
                                   name="to"
                                   value={to}
                                   disabled={ searchByMonth }
                                   onChange={e => setTo(e.target.value)}
                                   innerRef={register}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <br />
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}